export default class HubspotClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.postVisitorIdentificationRequest = this.postVisitorIdentificationRequest.bind(this);
    }
    postVisitorIdentificationRequest(data, config) {
        return this.apiClient.post('/v3/hs/visitor_identification', data, config);
    }
}
